import { takeEvery, put } from 'redux-saga/effects'
import { initialize } from 'redux-form/immutable'
import moment from 'moment'
import { Map } from 'immutable'
import { fetchSprintById } from 'store/entities/organizations/actions'
import { ORGANIZATION_SPRINT_FORM_EDIT } from 'app/domains/routes/Organizations/OrganizationSprintForms/OrganizationSprintFormEdit'

export default function* reinitializeFormSaga() {
  yield takeEvery(fetchSprintById.success.toString(), handleReinitializeFormSaga)
}

export function* handleReinitializeFormSaga({ payload: { data } }) {
  const values = Map({
    ...data,
    dates: Map({
      startDate: moment.tz(data.start, 'UTC'),
      endDate: moment.tz(data.end, 'UTC'),
    }),
  })
  yield put(initialize(ORGANIZATION_SPRINT_FORM_EDIT, values))
}
